<!-- 库存盘点 -->
<template>
	<div class="container flex flex-column height-all">
		<!-- 顶部搜索模块 -->
		<div class="searchContainer flex-shrink">
			<baseSearch :searchData="searchData" @searchClick="searchBtnClick" />
		</div>
		<!-- 主体表格 -->
		<div class="mainTable height-all overflow-hidden">
			<basetable tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="basetableinfo" :showopera="true" :currentPage="searchDataParam.pageNo" operaWidth="100" :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true" :showSelection="true" :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick" @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
				<template v-slot:checkStatus="scope">
					<div class="width-screen flex justify-center">
						<el-tag v-if="scope.scope.row.checkStatus == 1" type="success">已确认</el-tag>
						<el-tag v-if="scope.scope.row.checkStatus == 0" type="danger">未确认</el-tag>
					</div>
				</template>
				<template v-slot:opera="scope">
					<el-button type="primary" size="small" @click="openStockCheck(scope.scope,$event)">查看</el-button>
				</template>
			</basetable>
		</div>
	</div>
	<!-- 添加区域弹窗 -->
	<basedialog :title="checkStockInfo.checkName" :dialogVisible="isShowCheckStockCover" dialogWidth="600" @dialogConfirm="dialogConfirm" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose" :footerBtnType="checkStockInfo.checkStatus == 1 ? 'close':'cancelAndConfirm'">
		<template #dialogbody>
			<div v-html="checkStockInfo.desc"></div>
		</template>
	</basedialog>
</template>

<script>
	import baseSearch from "@/components/baseSearch"
	import basetable from "@/components/basetable"
	import basedialog from "@/components/basedialog"
	export default {
		inject: ['$http', '$api', '$utils', '$userUtils'],
		name: "stockCheck",
		components: {
			baseSearch,
			basetable,
			basedialog,
		},
		data() {
			return {
				searchData: [{
					label: "状态",
					type: "select",
					name: "state",
					options: [{
						label: "已确认",
						value: '1'
					}, {
						label: "未确认",
						value: '0'
					}],
				}, {
					label: "时间",
					type: "daterange",
					name: "timeDate",
					value: [],
					isHaveStar: true,
					valueFormat: 'YYYY-MM-DD',
					restrict: true,
					NoClearable:true,
					isShowDisabledDate:true,
					disabledDate:(time)=>{
						return time.getTime() > Date.now()
					},
				}],
				isLoading: false,
				tableTitle: [{
					label: '盘点确认单名称',
					prop: 'checkName',
				}, {
					label: '状态',
					prop: 'checkStatus',
					columnStyle:'custom',
					width: 220
				}, {
					label: '操作人',
					prop: 'checkClaimSysName',
					width: 180
				}, {
					label: '添加时间',
					prop: 'addDate',
					width: 220
				}],
				basetableinfo:[],
				searchDataParam:{
					pageNo:1,
					pageSize:20
				},
				isShowCheckStockCover:false,//是否显示盘点库存弹框
				checkStockInfo:{},
			}
		},
		mounted() {
			this.queryStockFactoryCheckRecord();
		},

		methods: {
			/**
			 * 初始化获取未打印电子面单列表
			 */
			queryStockFactoryCheckRecord() {
				let that = this;
				that.isLoading = true;
				console.log(that.searchDataParam)
				that.$http.post(that.$api.queryStockFactoryCheckRecordApi, {
					"pageNo": that.searchDataParam.pageNo,
					"pageSize": that.searchDataParam.pageSize,
					"state": that.searchDataParam.state,
					"startDay": that.searchDataParam.startDay,
					"endDay": that.searchDataParam.endDay,
				}).then(res => {
					that.isLoading = false;
					if (that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
					that.basetableinfo = res.data.list;
				})
			},
			/**
			 * 搜索按钮
			 */
			searchBtnClick(option) {
				let that = this;
				this.searchDataParam = Object.assign(this.searchDataParam, option);
				if(!this.$utils.isEmpty(option.timeDate)){
					this.searchDataParam.startDay = option.timeDate[0];
					this.searchDataParam.endDay = option.timeDate[1];
				}else{
					this.searchDataParam.startDay = '';
					this.searchDataParam.endDay = '';
				}
				this.queryStockFactoryCheckRecord();
			},
			/**
			 * 设置页码
			 */
			currentChange(val) {
				this.searchDataParam.pageNo = val;
				this.queryStockFactoryCheckRecord()
			},
			/**
			 * 设置页码
			 */
			sizeChange(val) {
				this.searchDataParam.pageSize = val;
				this.queryStockFactoryCheckRecord()
			},
			/**
			 * 查看库存盘点详情
			 */
			openStockCheck(scope,event){
				let target = event.target;
				if(target.nodeName == "SPAN"){
				  target = event.target.parentNode;
				}
				target.blur();
				this.isShowCheckStockCover = true;
				this.checkStockInfo = scope.row;
			},
			/**
			 * 确认盘点
			 */
			dialogConfirm(){
				this.$http.post(this.$api.updateStockFactoryCheckRecordApi,{
					dataId:this.checkStockInfo.dataId,
					desc:'1'
				}).then(res=>{
					if(res.code == 200){
						this.$message.success('操作完成');
						this.isShowCheckStockCover = false;
					}
				})
			},
			/**
			 * 取消确认
			 */
			dialogClose(){
				this.isShowCheckStockCover = false;
			}
		},
	}
</script>
<style scoped>
	.mainCont .container {
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 12px;
		box-sizing: border-box;
	}
</style>